import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { AiOutlineClose } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';

const CloseInvoiceToolModal = ({ show, onHide, closeInvoiceTool }) => {
    const { t } = useTranslation();
    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header>
                <Modal.Title>{t('Close Invoice Tool')}</Modal.Title>
                <AiOutlineClose className="ml-auto cursor-pointer" size={24} onClick={onHide} />
            </Modal.Header>
            <Modal.Body>
                {t('Are you sure you want to close the invoice tool? Any changes will be removed.')}
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={onHide}
                >
                    {t('No')}
                </Button>
                <Button className="text-light" variant="primary" onClick={closeInvoiceTool}>
                    {t('Yes')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CloseInvoiceToolModal;